// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const SyncIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="SyncIcon" ref={forwardedRef} {...props}>
      <path d="M7.007 8.505c-.068-.005.07 0 0 0C4.825 8.055 3.5 9.617 3.5 11A2.5 2.5 0 0 0 6 13.5h9c.968-.138 1.5-.995 1.5-2 .061-.379-.035-2.315-3.597-2.315C12.42 6.186 10.728 6 10 6 8.98 6 7.886 6.914 7.007 8.505M15 15H6c-2.209 0-4-1.791-4-4.001s1.905-4.257 4.302-4C6.956 5.63 8.382 4.5 10 4.5c2.03 0 3.433 1.132 4.157 3.423C16.09 7.922 18 9.566 18 11.5c0 1.763-1.304 3.258-3 3.501" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const SyncIcon = /* @__PURE__ */ Object.assign(SyncIconComponent, {
  displayName: 'SyncIcon',
});
